import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

type Props = TextFieldProps & {
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
  validateIsNotEmpty?: boolean | undefined;
};

function TextField(props: Props) {
  const { validateIsNotEmpty = false, handleChange, handleBlur, ...rest } = props;

  return (
    <MuiTextField
      variant='standard'
      required={validateIsNotEmpty || false}
      fullWidth
      onChange={(event) => handleChange(event.target.value)}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
      }}
      {...rest}
    />
  );
}

export type { Props as TextFieldProps };

export default TextField;
